function toDouble (n) {
  return n < 10 ? `0${n}` : `${n}`
}

export default function dateToDateString (date, dateSeparator = '/') {
  return [
    date.getFullYear(),
    toDouble(date.getMonth() + 1),
    toDouble(date.getDate()),
  ].join(dateSeparator)
}



// WEBPACK FOOTER //
// ./src/libs/date-to-date-string.js